// <copyright file="MapUtils.ts">
// © 2023 Florida Department of Transportation
//
// The copyright to the computer program(s) and source code herein is
// the property of the Florida Department of Transportation.
// The program(s) and source code may be used and/or copied only with the
// written permission of the Florida Department of Transportation or
// in accordance with the terms and conditions stipulated in the
// agreement/contract under which the program(s) and source code have
// been supplied.
// </copyright>

/********************************************************
 * Shared utilities to be used across UI test components
 ********************************************************/

export interface PopupInfoTableProps {
    title: string | null; // optional title to display
    data: [string, unknown][]; // data keys and values
}

/**
 * Creates raw HTML for a 2-column vertical table to display content in map marker popups
 * @param props Properties used to create the table html
 */

export function popupInfoTable(props: PopupInfoTableProps): string {
    // Use inline styles below, because this method returns raw HTML
    const containerStyle = "max-height: 200px; overflow-y: auto;";
    const tableStyle = "width:100%; border-collapse: collapse";
    const thStyle = "border: solid 1px; padding: 5px;";
    const tdStyle = "border: solid 1px; padding: 5px; word-break: break-all";
    const info: string[] = [];
    if (props.title) {
        info.push(
            `<tr><th colSpan=2 style="${thStyle}">${props.title}</th></tr>`
        );
    }

    props.data.forEach((d) => {
        const key =
            d[0].length == 1
                ? d[0].toUpperCase()
                : d[0].charAt(0).toUpperCase() + d[0].substring(1);
        const value = `${d[1]}`;
        info.push(
            `<tr><th style="${thStyle}">${key}</th><td style="${tdStyle}">${value}</td></tr>`
        );
    });
    return `<div style="${containerStyle}"><table style="${tableStyle}">\n${info.join("\n")}\n</table></div>`;
}
